import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useAccount } from "../hooks/useAccount"
import { usePatchPatient } from "../queries/usePatients"
import { useQueryClient } from "@tanstack/react-query"

export const SurgeryCategory = () => {
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const { account } = useAccount()
  const { mutateAsync: patchPatient, isPending } = usePatchPatient(
    account.patient_id
  )

  const [surgeryCategory, setSurgeryCategory] = useState<string>()

  const onPatchPatient = () => {
    surgeryCategory !== undefined &&
      patchPatient({
        patient: {
          surgery_category: surgeryCategory
        }
      }).then(() => {
        queryClient.invalidateQueries({
          queryKey: ["patient", account.patient_id]
        })
        queryClient.invalidateQueries({
          queryKey: ["patient_surveys"]
        })
      })
  }

  return (
    <div className="flex w-full h-full bg-cortexx-50 flex-1 flex-col justify-center items-center mx-4">
      <div className="flex flex-col w-full h-5/6 md:w-3/4 md:h-3/4 lg:w-1/2 lg:h-1/2 border-slate-300 border pt-8 pb-2 px-2 shadow-md rounded-xl">
        <div className="flex h-5/6 flex-col gap-4 justify-start items-center text-center w-full">
          <div className="flex flex-col flex-1 gap-4">
            <h1 className="text-lg text-cortexx-550 font-bold">
              {t("surgery.title")}
            </h1>
            <h1 className="text-md text-cortexx-550">
              {t("surgery.description")}
            </h1>
          </div>
          <ul className="flex flex-1 w-full flex-col items-center gap-4">
            <div className="flex flex-col md:w-1/2 w-full">
              <button
                className={
                  surgeryCategory === "lumbar"
                    ? "text-cortexx-50 font-bold transition-colors duration-500"
                    : "text-cortexx-550 font-bold transition-colors duration-500"
                }
                onClick={() => setSurgeryCategory("lumbar")}
              >
                <li
                  className={
                    surgeryCategory === "lumbar"
                      ? "border bg-cortexx-500 rounded-lg py-3 px-4 transition-colors duration-500"
                      : "border bg-cortexx-100 rounded-lg py-3 px-4 transition-colors duration-500"
                  }
                >
                  {t("surgery.lumbar")}
                </li>
              </button>
            </div>
            <div className="flex flex-col md:w-1/2 w-full">
              <button
                className={
                  surgeryCategory === "cervical"
                    ? "text-cortexx-50 font-bold transition-colors duration-500"
                    : "text-cortexx-550 font-bold transition-colors duration-500"
                }
                onClick={() => setSurgeryCategory("cervical")}
              >
                <li
                  className={
                    surgeryCategory === "cervical"
                      ? "border bg-cortexx-500 rounded-lg py-3 px-4 transition-colors duration-500"
                      : "border bg-cortexx-100 rounded-lg py-3 px-4 transition-colors duration-500"
                  }
                >
                  {t("surgery.cervical")}
                </li>
              </button>
            </div>
          </ul>
        </div>
        <div className="flex h-1/6 items-end justify-end">
          {!isPending ? (
            <button
              onClick={onPatchPatient}
              disabled={surgeryCategory === "" || surgeryCategory === undefined}
              className=" text-cortexx-550 font-semibold py-3 px-5 rounded-lg text-sm"
            >
              {t("surgery.next")}
            </button>
          ) : (
            <button
              className="bg-cortexx-100 text-white font-semibold py-3 px-5 rounded-lg"
              disabled
            >
              <img
                src="/images/fade-stagger-circles.svg"
                style={{ height: "20px" }}
                alt="close"
                loading="lazy"
              />
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
